import { createContext, useContext } from "react";

// Provided by MainLayout. Default true to avoid flash on load.
export const WhatsAppStatusContext = createContext(true);
export const useWhatsAppStatus = () => useContext(WhatsAppStatusContext);
